<template>
	<div>
        <!-- <v-bottom-sheet persistent v-model="dialog_selection" v-if="dialog_selection"> -->
        <dialog ref="ref_nativeDialog" class="native_sheet" v-if="dialog_selection" full-width>
            <v-card flat class="dialog_sheet_native" v-if="propertyObj">
                <div class="sticky-header">
                    <v-subheader class="pa-0">
                        <v-btn icon class="mt-0 mb-0" @click="closeDialog"><v-icon>close</v-icon></v-btn>
                        Select {{ propertyObj.ToolbarTitle }}
                        <v-spacer></v-spacer>
                        <v-btn flat icon @click="fnAction(null, null, propertyObj.action)" v-if="propertyObj.action">
                            <v-icon color="primary">add</v-icon>
                        </v-btn>
                        <v-btn flat color="primary" nomargin @click="fnOnChange(null, propertyObj.ref, null, null, true)" v-if="propertyObj.clearBtn">
                            Clear
                        </v-btn>
                    </v-subheader>
                    <v-text-field v-model="searchVal" @input="fn_debounceSearch" clearable single-line solo flat placeholder="Search" hide-details class="bottomsheet-search" :height="42"></v-text-field>
                </div>
                <v-card-text full-height nopadding>
                    <v-list nopadding v-if="!loading && (filteredItems && filteredItems.length)">
                        <v-list-tile v-for="(item, index) in filteredItems" :key="index" @click="fn_setSelectionItem(item.itemId, item.itemName)">
                            <v-list-tile-content>
                                <v-list-tile-title>{{item.itemName}}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-icon :color="propertyObj.selectedItem && item.itemId === propertyObj.selectedItem.itemId ? 'primary' : ''">{{ propertyObj.selectedItem && item.itemId === propertyObj.selectedItem.itemId ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
                            </v-list-tile-action>
                        </v-list-tile>
                    </v-list>

                    <div class="pa-4 center-align display_msg" v-if="!loading && (!filteredItems || !filteredItems.length)">
                        Not found!
                    </div>
                </v-card-text>
            </v-card>
        </dialog>
        <!-- </v-bottom-sheet> -->
	</div>
</template>

<script>
	export default{
		props:['fnAction', 'closeDialog', 'fnOnChange'],
		data(){
			return{
				dialog_selection:false,
                items:null,
                filteredItems:null,
				searchVal:null,
				timeoutid:null,
				loading:false,
                propertyObj:null
			}
		},
		methods:{
			openDialogWeb: function () {
				this.searchVal = null;
				this.propertyObj = localStorage.getItem('dialog_properties') ? JSON.parse(localStorage.getItem('dialog_properties')) : null;
				this.dialog_selection = true;
                if(this.propertyObj.hasLocalItems){
                    this.items = this.$parent.fn_getlocalItems();
                    this.fn_filterItems();
                }
                else{
                    this.fn_getitems();
                }

                setTimeout(() => {
					this.$refs['ref_nativeDialog'].showModal();
				}, 100);
			},
			closeDialogWeb: function () {
                this.$refs['ref_nativeDialog'] ? this.$refs['ref_nativeDialog'].close() : '';
				this.dialog_selection = false;
			},
            fn_setSelectionItem: function(itemId, itemName){
                this.fnOnChange(null, this.propertyObj.ref, itemId, itemName);
				this.closeDialog();
            },
			fn_debounceSearch: function(){
				if (this.timeoutid != null){
					clearTimeout(this.timeoutid);
				}

				this.timeoutid = setTimeout(() => { 
                    if(this.propertyObj.dbSearch){
                        this.fn_getitems();
                    }
                    else{
                        this.fn_filterItems();
                    }
				},300);
			},
            fn_getitems: function () {
				this.loading = true;
				this.items = null;

                let filterObject = {};
                filterObject.search = this.searchVal ? this.searchVal.toLowerCase() : '';

                if(this.propertyObj.accountGroupIds){
                    filterObject.accountGroupIds = this.propertyObj.accountGroupIds
                }

                if(this.propertyObj.listId){
                    filterObject.listId = this.propertyObj.listId;
                }

                if(this.propertyObj.addOnType){
                    filterObject.addOnType = this.propertyObj.addOnType;
                }

                if(this.propertyObj.transactionTypeId){
                    filterObject.transactionTypeId = this.propertyObj.transactionTypeId;
                }

                if(this.propertyObj.accountGroupsHidden){
                    filterObject.accountGroupsHidden = this.propertyObj.accountGroupsHidden;
                }

				filterObject.startIndex = 0;
				filterObject.limit = 100;

                let self = this;
                this.getDialogItems(self.propertyObj.fnName, filterObject, 
                    {
                        onSuccess: function(response){
							console.log(response);
                            self.items = JSON.parse(response);
							if(self.propertyObj.selectedItem && self.propertyObj.selectedItem.itemId && self.items && self.items.length){
								// finding index of selected item
								let selectedItemIndex = self.items.findIndex(item=>item.itemId === self.propertyObj.selectedItem.itemId);
								// removing selected item from the list
								if(selectedItemIndex != -1){
									self.items.splice(selectedItemIndex, 1);
								}
								// pushing selected item to the top
								self.items.unshift(self.propertyObj.selectedItem);
							}

                            self.fn_filterItems();

							self.loading = false;
                        }, 
                        onError: function(error){
                            console.log(error);
							self.loading = false;
                        }
                    }
                );
            },
            fn_filterItems: function(){
                this.filteredItems = [];
                if(this.items && this.items.length){
                    let searchText = this.searchVal ? this.searchVal.toLowerCase() : '';
                    this.filteredItems = this.items.filter(item=>{
                        return item.itemName.toLowerCase().match(searchText);
                    })
                }
                return this.filteredItems;
            }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_selection_list.vue